// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-form-item[data-v-3a43ccf9] {\n  margin-bottom: 0 !important;\n}\n.list[data-v-3a43ccf9] {\n  padding-bottom: 0 !important;\n}\n.case-creation__body[data-v-3a43ccf9] {\n  padding-bottom: 10px;\n}", ""]);
// Exports
module.exports = exports;
